import { Box, Typography } from '@mui/material'
import React from 'react'
import TopBar from './TopBar'
import NotificationContainer from './NotificationsContainer'
import { useState } from 'react'
import PrivacyContainer from './PrivacyContainer'
import ManagementContainer from './ManagementContainer'
import FRTManagementContainer from './FRTManagementContainer'

const SettingsContainer = () => {

  const [activeTab, setActiveTab] = useState(0);
  console.log("Active Tab in Settings Container:", activeTab);

  const renderPage = () => {
    switch (activeTab) {
      case 0:
        return <ManagementContainer />;
      case 1:
        return <FRTManagementContainer />;
      default:
        return null;
    }
  };

  // const renderPage = () => {
  //   return <ManagementContainer/>
  // };

  return (
    <>
      <Box sx={{ margin: '1rem' }}>
        <Typography
          variant="h2" // You might need to adjust this for the right size
          sx={{
            fontFamily: 'Roboto',
            fontSize: '40px',
            fontWeight: '400',
            lineHeight: '47px',
            letterSpacing: '0em',
            textAlign: 'left',
            color: '#212121',
          }}
        >
          Settings
        </Typography>
        <Box sx={{ marginTop: '1rem' }}>
          <TopBar activeTab={activeTab} setActiveTab={setActiveTab} />
        </Box>
        {renderPage()}
      </Box>



    </>
  )
}

export default SettingsContainer